var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M6.6,37.2h31.7c0.2,0,0.4-0.2,0.4-0.4v-8.3h-0.1v-0.2l-3.2-5.6c0-0.1-0.1-0.2-0.2-0.2h-5.1 c0.9-2.9,2.2-6.3,3.1-8.4c0.3-0.7,0.6-1.4,0.8-2.1c0-2.9-6.1-4.2-10.2-4.2c-1.7,0-3.4,0.3-5,0.8c-1.4,0.5-2.2,1-2.2,1.9v1.8h-1.7 c-1.3-0.2-2.5-0.2-3.8,0c-0.9,0.1-1.7,0.7-2,1.5c-0.1,0.9,0.2,1.7,0.8,2.3c0.5,0.6,1.4,3.3,2.3,6.4H9.1c-0.2,0-0.3,0.1-0.3,0.2 l-2.4,5.5c-0.1,0.1-0.1,0.1-0.1,0.2v8.4C6.3,37,6.4,37.2,6.6,37.2z M19.1,9.1c1.5-0.5,3.1-0.7,4.7-0.7c4.5,0,9.5,1.5,9.5,3.6 c-0.2,0.7-0.4,1.3-0.7,1.9c-1.2,2.9-2.2,5.8-3.1,8.8h-0.1c-0.4,1.2-0.5,2.5-0.5,3.8l-6.3,0.2h-3.5c0.4-5,0.6-10,0.4-15 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.4-0.5-0.8-0.9-1l-1-0.5L19.1,9.1z M18.2,10.9c0.4,0.2,0.6,0.4,0.6,0.7c0.1,0.1,0.1,0.4,0,0.5 c-0.4,0.2-0.9,0.3-1.4,0.2l-0.2-1.8L18.2,10.9z M10.3,15.7c-0.5-0.5-0.7-1.1-0.6-1.8c0.3-0.6,0.8-1,1.5-1.1c1.2-0.2,2.5-0.2,3.7,0 H17c0.6,0.1,1.3,0.1,1.9-0.2c0.2,4.7,0.1,9.3-0.4,14l-4.3-0.4H14c-0.3-0.6-0.5-1.3-0.6-2c-0.2-0.4-0.3-0.9-0.5-1.4 C12.1,19.9,11,16.5,10.3,15.7z M9.3,23.1h3.1l0.3,0.9c-1.9,0.3-2.7,0.7-2.7,1.3c0,0.6,0.5,1.1,3.9,1.6l4.7,0.4h4 c6.2,0.1,10.7-0.5,11.6-1.4c0.2-0.1,0.3-0.3,0.3-0.5c0-0.5-1-1-1.5-1.1c-1-0.4-2.1-0.6-3.2-0.6c0.1-0.2,0.1-0.5,0.2-0.7h5l2.8,5 H7.1L9.3,23.1z M6.9,28.8H38v7.7H6.9V28.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M18.8,12.1c0.1-0.1,0.1-0.4,0-0.5c0-0.3-0.2-0.5-0.6-0.7l-1-0.4l0.2,1.8C17.9,12.4,18.4,12.3,18.8,12.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M19.4,11.5c0,0.1,0.1,0.1,0.1,0.2c0.2,5,0,10-0.4,15h3.5l6.3-0.2c0-1.3,0.1-2.6,0.5-3.8h0.1 c0.9-3,1.9-5.9,3.1-8.8c0.3-0.6,0.5-1.2,0.7-1.9c0-2.1-5-3.6-9.5-3.6c-1.6,0-3.2,0.2-4.7,0.7L17.5,10l1,0.5 C18.9,10.7,19.3,11.1,19.4,11.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M12.9,22.8c0.2,0.5,0.3,1,0.5,1.4c0.1,0.7,0.3,1.4,0.6,2h0.2l4.3,0.4c0.5-4.7,0.6-9.3,0.4-14 c-0.6,0.3-1.3,0.3-1.9,0.2h-2.1c-1.2-0.2-2.5-0.2-3.7,0c-0.7,0.1-1.2,0.5-1.5,1.1c-0.1,0.7,0.1,1.3,0.6,1.8 C11,16.5,12.1,19.9,12.9,22.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M37.8,28L35,23h-5c-0.1,0.2-0.1,0.5-0.2,0.7c1.1,0,2.2,0.2,3.2,0.6c0.5,0.1,1.5,0.6,1.5,1.1 c0,0.2-0.1,0.4-0.3,0.5c-0.9,0.9-5.4,1.5-11.6,1.4h-4l-4.7-0.4c-3.4-0.5-3.9-1-3.9-1.6c0-0.6,0.8-1,2.7-1.3l-0.3-0.9H9.3L7.1,28 H37.8z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 6.9,
  y: 28.8,
  fill: "#FFFFFF",
  width: 31.1,
  height: 7.7
}));

function SvgTissues(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTissues);
export default __webpack_public_path__ + "static/media/tissues.77e7fd66d4c4f7306e000e290529dab7.svg";
export { ForwardRef as ReactComponent };